
import Router from 'src/routes/sections';

import 'src/global.css';
import 'src/locales/i18n';
import ThemeProvider from 'src/theme';

import ProgressBar from 'src/components/progress-bar';
import { SettingsProvider } from 'src/components/settings';
import { MotionLazy } from 'src/components/animate/motion-lazy';

import { useApp } from './hooks/use-app';
import { LocalizationProvider } from './locales';
import { SnackbarProvider } from './components/snackbar';
import { AnalyticsProvider } from './providers/analytics-provider';
import ConfettiDialog from './components/confetti-dialog/confetti-dialog';
import MyInterestDialog from './components/my-interest-dialog/my-interest-dialog';
import SendNotesBottomsheet from './components/send-notes-bottomsheet/send-notes-bottomsheet';
import MyInterestsInviteDialog from './components/my-interests-invite-dialog/my-interests-invite-dialog';

export default function App() {

  const {
    openQuizDialog,
    useMyInterestsDialog,
    openConfettiDialog,
    handleCloseQuizDialog,
    handleRespondQuiz,
    handleCloseConfetti
  } = useApp()
  

  return (
    <LocalizationProvider>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'light',
          themeDirection: 'ltr',
          themeContrast: 'default',
          themeLayout: 'horizontal',
          themeColorPresets: 'default',
          themeStretch: false,
        }}
      >
        <ThemeProvider>
          <AnalyticsProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ProgressBar />
                <Router />
                <SendNotesBottomsheet />
                <MyInterestsInviteDialog
                  open={openQuizDialog}
                  onClose={handleCloseQuizDialog}
                  onRespond={handleRespondQuiz}
                />
                {useMyInterestsDialog &&
                  <MyInterestDialog open={useMyInterestsDialog} />
                }
                <ConfettiDialog open={openConfettiDialog} onClose={handleCloseConfetti} />
              </SnackbarProvider>
            </MotionLazy>
          </AnalyticsProvider>
        </ThemeProvider>
      </SettingsProvider>
    </LocalizationProvider>
  );
}
